<template>
  <!-- 用户管理-余额日志记录 -->
  <div class="category">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="query.uid" placeholder="请输入用户uid"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="pull-right" type="primary" @click="handleSearch"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="handleExport"
          :loading="buttonLoading"
        >
          导出
        </el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="user_id" label="用户UID"></el-table-column>
        <el-table-column prop="user_name" label="用户名"></el-table-column>
        <el-table-column
          prop="before_money"
          label="变动前金额"
        ></el-table-column>
        <el-table-column
          prop="after_money"
          label="变动后金额"
        ></el-table-column>
        <el-table-column prop="change_money" label="变动金额"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="created_at" label="时间"></el-table-column>
      </el-table>
      <el-pagination
        background
        :total="dataMeta ? dataMeta.total : 0"
        :current-page="dataMeta ? dataMeta.current_page : 1"
        :page-size="dataMeta ? dataMeta.per_page : 15"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import http, { getData, server, getApiData } from '@/http'
import saveFile from '@/utils/saveFile'
export default {
  data() {
    return {
      buttonLoading: false,//加载按钮动画
      dataList: undefined,
      dataMeta: {},
      logData: undefined,
      logDataMeta: {},
      query: {
        page: 1,
        uid: undefined,
        start_time: undefined,
        end_time: undefined
      },
      log: {
        page: 1
      },
      loading: false,
      visible: false,
    }
  },
  methods: {
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      let params = this.query
      getApiData(`account_balance_record`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    handleExport() {
      if (!this.query.start_time || !this.query.end_time) {
        this.$message.warning('开始时间与结束时间必须填写')
        return
      }
      if (this.buttonLoading) {
        this.$message.success('正在导出请勿重复点击')
        return
      }
      this.buttonLoading = true
      http
        .post(
          server + `account_balance_export`,
          this.query,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '余额日志.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="less">
.table-image {
  max-height: 100px;
  max-width: 100px;
}

.avatar-uploader {
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
</style>
